<template>
  <div id="modalUploadResumoTfl">
    <q-dialog v-model="OpenDialogUploadResumoCaixas" v-if="!($q.platform.is.mobile && movmentacao)" full-width persistent>
      <q-card style="width: auto !important">
        <div class="modal">
          <q-card-section class="row items-center">
            <div class="text-h6">{{ title }} <span v-if="reviewingFile" class="text-h6">- {{ reviewingFile.nome }} </span> </div>
            <q-space />
            <q-btn icon="close" flat round dense v-close-popup @click="close()" />
          </q-card-section>

          <q-separator />

          <div class="row">
            <div class="col-12 col-md">
              <q-card-section>
                <!-- Em modo movimentação o modal só serve ao login por QR (ver os pais
                     modal-detalhar-movconta e modal-nova-recorrência): não há lista de
                     arquivos nem caixa para onde importar, então não há o que escolher. -->
                <painel-qrcode v-if="movmentacao" :url-qrcode="urlQrcode" :size="size" />

                <template v-else>
                  <q-tabs
                    :model-value="abaAtiva"
                    @update:model-value="trocarAba"
                    dense
                    align="justify"
                    narrow-indicator
                    class="text-primary"
                  >
                    <q-tab
                      v-for="aba in abas"
                      :key="aba.nome"
                      :name="aba.nome"
                      :icon="aba.icone"
                      :label="aba.label"
                    />
                  </q-tabs>

                  <q-separator />

                  <q-tab-panels :model-value="abaAtiva" animated>
                    <q-tab-panel v-if="mostraAbaCelular" name="celular">
                      <painel-qrcode :url-qrcode="urlQrcode" :size="size" />
                    </q-tab-panel>

                    <q-tab-panel name="arquivo" class="q-pa-none">
                      <painel-arquivo
                        ref="painelArquivo"
                        :uploads="uploads"
                        :arquivos="arquivos"
                        :reviewing-file="reviewingFile"
                        :carregando="carregando"
                        :carregando-img-id="carregandoImgId"
                        @arquivo-selecionado="processarSelecao"
                        @arquivo-removido="apagaItem"
                        @arquivo-revisado="reviewItem"
                      />
                    </q-tab-panel>

                    <q-tab-panel v-if="podeUsarRelatorioCaixa" name="conexao">
                      <painel-conexao-caixa
                        :consultando="relatorioConsultando"
                        :mensagem-progresso="conexaoCaixaMensagemProgresso"
                        :tem-erro="conexaoCaixaRelatorioTemErro"
                        :erro="conexaoCaixaRelatorioErro"
                        :relatorio-carregado="relatorioCaixaCarregado"
                        :carregando="carregandoRelatorioCaixa"
                        :pode-consultar="conexaoCaixaPodeRelatorio"
                        :bloqueio="conexaoCaixaRelatorioBloqueio"
                        :retorno-importacao="retornoImportacaoCaixa"
                        :enviando="enviandoRelatorioCaixa"
                        :pode-enviar="podeEnviarRelatorioCaixa"
                        @consultar="consultarRelatorioCaixa"
                        :base="conexaoCaixaRelatorioBase"
                        @enviar="enviarRelatorioCaixa(false)"
                        @ciente="fecharAposImportacaoCaixa"
                        @liberar="confirmarLiberacao"
                      />
                    </q-tab-panel>
                  </q-tab-panels>
                </template>
              </q-card-section>
            </div>

            <div class="col-10 col-md-9 q-mt-md" v-if="reviewingFile">
              <q-card-section class="q-pa-none">
                <div>
                  <img id="reviewingImage" :style="resumoImgWidth" :src="reviewingFile.server_url" @load="setDimensoesImagem"  />
                  <div v-if="isImgLoaded" style="width: 1200px;">
                    <div v-for="block in reviewingFile.raw" :key="block.id" :style="calculaArea(block)" @click="toggleBloco(block)" :id="block.Id">
                      <div v-if="isAtivo(block)" style="margin-left: 576px; margin-top: -16px; font-size: 14px; user-select: none;">
                        <pre>{{ block.Text }}</pre>
                      </div>
                    </div>
                  </div>
                  <div v-else class="row flex-center q-ma-lg">
                    <q-spinner color="grey-10" size="5em" />
                  </div>
                </div>
              </q-card-section>
            </div>
          </div>

          <!-- Fluxo do OCR. O "Enviar para o caixa" mudou de lugar: agora mora no
               painel da Conexão Parceiro, junto do resultado que ele envia. -->
          <q-card-actions
            v-if="mostraAcoesOcr"
            align="center"
            class="text-primary q-mb-md"
          >
            <q-btn flat label="Salvar processamento e Tirar nova foto" clickable @click="enviaDadosOCR"
              :disable="disableButton" class="bg-primary  text-white q-ma-xs">
              <template v-slot:loading>
                <q-spinner color="grey-10" size="1em" />
              </template>
            </q-btn>
            <q-btn flat label="Salvar processamento" clickable @click="enviaDadosOCR(false)" :disable="disableButton"
              class="bg-green text-white q-ma-xs">
              <template v-slot:loading>
                <q-spinner color="grey-10" size="1em" />
              </template>
            </q-btn>
          </q-card-actions>
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { Notify, Dialog } from "quasar";
import axios from "@/axios-auth";
import { mapGetters, mapState } from "vuex";
import PainelQrcode from "@/components/Caixas/ResumoTfl/PainelQrcode.vue";
import PainelArquivo from "@/components/Caixas/ResumoTfl/PainelArquivo.vue";
import PainelConexaoCaixa from "@/components/Caixas/ResumoTfl/PainelConexaoCaixa.vue";
import { temPendencias, textoConfirmacaoLiberacao } from "@/components/Caixas/ResumoTfl/importacaoCaixa";

export default {
  name: "modal-upload-resumo-tfl",
  props: ['movmentacao', 'title'],
  components: {
    PainelQrcode,
    PainelArquivo,
    PainelConexaoCaixa
  },
  data() {
    return {
      size: 200,
      ocupado: "",
      percent: null,
      tamanho: "",
      errors: [],
      selectedFile: null,
      uploadProgress: "",
      uploading: false,
      success: true,
      porcentagem: 0,
      fileName: "",
      fileSize: null,
      uploads: [],
      carregando: false,
      carregandoImgId: null,
      downloading: false,
      interval: '',
      arquivos: [],
      loadingArquivos: false,
      reviewingFile: null,
      blocosMapeados: [],
      blocosAlterados: [],
      isImgLoaded: false,
      dimensoesImagem: null,
      carregandoRelatorioCaixa: false,
      relatorioCaixaCarregado: false,
      dadosRelatorioCaixa: null,
      enviandoRelatorioCaixa: false,
      retornoImportacaoCaixa: null,
      abaAtiva: null,
      // Zerados a cada abertura do modal: cada caminho caro dispara no máximo
      // uma vez por sessão do modal. Ver reiniciarAbas().
      caixaJaConsultada: false,
      seletorJaAberto: false,
    };
  },
  computed: {
    ...mapGetters([
      "imgOCRId",
      "caixaId",
      "urlQrcode",
      "despesaQrCode",
      "movcaixa",
      "permissoesCaixas",
      "conexaoCaixaDisponivel",
      "conexaoCaixaVinculoAtivo",
      "conexaoCaixaAtivo",
      "conexaoCaixaAplicavel",
      "conexaoCaixaMensagemProgresso",
      "conexaoCaixaRelatorioTemErro",
      "conexaoCaixaRelatorioConcluido",
      "conexaoCaixaRelatorioProcessando",
      "conexaoCaixaPodeRelatorio",
      "conexaoCaixaRelatorioBloqueio",
    ]),
    // Módulo não-namespaced → state fica em state.conexao_caixa.* (não no root).
    ...mapState({
      conexaoCaixaRelatorioErro: state => state.conexao_caixa.conexaoCaixaRelatorioErro,
      conexaoCaixaRelatorioResultado: state => state.conexao_caixa.conexaoCaixaRelatorioResultado,
      conexaoCaixaRelatorioJobId: state => state.conexao_caixa.conexaoCaixaRelatorioJobId,
      conexaoCaixaRelatorioBase: state => state.conexao_caixa.conexaoCaixaRelatorioBase,
      conexaoCaixaRelatorioCaixaId: state => state.conexao_caixa.conexaoCaixaRelatorioCaixaId,
    }),
    // Escanear o QR no próprio aparelho não faz sentido — no mobile a aba some.
    mostraAbaCelular() {
      return !this.$q.platform.is.mobile;
    },
    abaPadrao() {
      return this.mostraAbaCelular ? "celular" : "arquivo";
    },
    abas() {
      const abas = [];

      if (this.mostraAbaCelular) {
        abas.push({ nome: "celular", label: "Celular", icone: "smartphone" });
      }

      abas.push({ nome: "arquivo", label: "Arquivo", icone: "cloud_upload" });

      if (this.podeUsarRelatorioCaixa) {
        abas.push({ nome: "conexao", label: "Conexão Parceiro", icone: "account_balance" });
      }

      return abas;
    },
    mostraAcoesOcr() {
      // O rodapé é do fluxo do OCR: na aba do Conexão Parceiro não há foto
      // nenhuma para processar, e o envio ao caixa mora no painel dela.
      return this.abaAtiva !== "conexao" &&
        !this.movmentacao &&
        !this.relatorioConsultando &&
        !this.relatorioCaixaCarregado &&
        !!this.movcaixa &&
        this.movcaixa.status === "A";
    },
    podeEnviarRelatorioCaixa() {
      const base = this.conexaoCaixaRelatorioBase;
      const bloqueadoSemLiberacao = !!(base && base.requer_liberacao && !base.pode_liberar);
      // O job_id do store é de quem pediu: só envia para o mesmo caixa.
      return !this.enviandoRelatorioCaixa &&
        !!this.conexaoCaixaRelatorioJobId &&
        this.conexaoCaixaRelatorioCaixaId === this.caixaId &&
        !bloqueadoSemLiberacao;
    },
    // Quem VÊ a aba, não quem pode usá-la agora. Esconder porque falta configurar
    // é pior do que mostrar explicando o que falta — o usuário nem descobre que o
    // recurso existe. Some só para quem não tem como agir: não é lotérica, não
    // contratou o app, ou não tem a permissão de relatórios. O liga/desliga dos
    // Parâmetros e o estado do agente viram motivo de bloqueio dentro do painel.
    podeUsarRelatorioCaixa() {
      const temPermissao = !!(this.permissoesCaixas && this.permissoesCaixas["ConexaoCaixas.relatorios"]);
      return this.conexaoCaixaAplicavel === true && temPermissao;
    },
    // Verdade única de "consultando relatório": cobre tanto a janela síncrona do
    // clique (carregandoRelatorioCaixa, flag local) quanto o polling em segundo
    // plano (estado no store), que sobrevive a fechar/reabrir o modal nos ~2min.
    relatorioConsultando() {
      return this.conexaoCaixaRelatorioProcessando || this.carregandoRelatorioCaixa;
    },
    importacaoCaixaComPendencias() {
      return temPendencias(this.retornoImportacaoCaixa);
    },
    imagemAtribuida() {
      let message = "";
      if (this.imgOCRId) message = "Caixa com Resumo";
      else message = "Caixa sem Resumo";

      return message;
    },
    defineColor() {
      let color = "";
      if (this.imgOCRId) color = "background-color: #4CAF50; color: white;";
      else color = "background-color: #F44336; color: white;";

      return color;
    },
    disableButton() {
      return (this.carregando || this.uploading) || this.arquivos.length == 0;
    },
    resumoImgWidth() {
      if (this.$q.screen.width > 700) {
        return "width: 600px;";
      }

      if (this.$q.screen.width > 600) {
        return "width: 500px;";
      }

      if (this.$q.screen.width > 500) {
        return "width: 400px;";
      }

      return "width: 300px;";
    },
    OpenDialogUploadResumoCaixas: {
      get() {
        return this.loadQrcode();
      },
      set() {}
    }
  },
  methods: {
    // Entrar na aba É a escolha do caminho — não existe um segundo clique para
    // "começar". Por isso quem decide *quando* disparar é a casca: só ela sabe
    // se esta é a primeira entrada desta abertura do modal.
    trocarAba(aba) {
      if (aba === this.abaAtiva) return;
      this.abaAtiva = aba;

      if (aba === "conexao") this.aoEntrarNaAbaConexao();
      if (aba === "arquivo") this.aoEntrarNaAbaArquivo();
    },
    aoEntrarNaAbaArquivo() {
      if (this.seletorJaAberto) return;
      this.seletorJaAberto = true;

      // O painel só existe depois que o q-tab-panel dele renderiza.
      this.$nextTick(() => {
        const painel = this.$refs.painelArquivo;
        if (painel && typeof painel.abrirSeletor === "function") {
          painel.abrirSeletor();
        }
      });
    },
    aoEntrarNaAbaConexao() {
      if (this.caixaJaConsultada) return;

      // Consulta já em curso (o polling sobrevive a fechar/reabrir o modal) ou
      // resultado na mão: a aba só mostra o que já veio.
      if (this.relatorioConsultando || this.relatorioCaixaCarregado) {
        this.caixaJaConsultada = true;
        return;
      }

      // Agente não pronto: o painel exibe o motivo e o botão fica desabilitado.
      // Não marca a flag — se o agente subir, voltar à aba tenta de novo.
      if (!this.conexaoCaixaPodeRelatorio) return;

      this.caixaJaConsultada = true;
      this.buscarRelatorioCaixa();
    },
    reiniciarAbas() {
      this.caixaJaConsultada = false;
      this.seletorJaAberto = false;
      this.abaAtiva = this.abaPadrao;

      // Cair na aba Arquivo por ser o padrão (mobile) não é uma escolha do usuário:
      // não abre o seletor, e consome a primeira entrada para que voltar à aba
      // depois não abra o seletor de surpresa.
      if (this.abaAtiva === "arquivo") this.seletorJaAberto = true;
    },
    // Nova tentativa pelo botão do painel: consome a consulta da abertura para
    // que voltar à aba depois não dispare mais uma.
    consultarRelatorioCaixa() {
      this.caixaJaConsultada = true;
      this.buscarRelatorioCaixa();
    },
    async atualizarDadosAposImportacaoCaixa() {
      await this.$store.dispatch("buscaCaixa", this.caixaId);

      if (this.movcaixacategoria && this.movcaixacategoria.id) {
        await this.$store.dispatch("buscaProdutos", {
          categoriaId: this.movcaixacategoria.id,
          caixaId: this.caixaId
        });
      }
    },
    notificarErroConexaoCaixa(mensagem) {
      if (!mensagem) return;

      if (typeof mensagem === "string" && mensagem.startsWith("Sessão da Caixa expirou")) {
        this.$q.notify({
          message:  mensagem,
          color:    "orange",
          position: "top-right",
          timeout:  0,
          actions: [
            {
              label:   "Reconectar",
              color:   "white",
              handler: () => { this.$router.push("/parametros"); },
            },
            { label: "Fechar", color: "white" },
          ],
        });
        return;
      }

      this.$q.notify({
        message:  mensagem,
        color:    "red",
        position: "top-right",
      });
    },
    close(){
      if (this.blocosAlterados.length > 0) {
        Dialog.create({
          title: "Sair dessa tela sem processar o resumo TFL fará com ele seja descartado.",
          message: "Tem certeza que quer prosseguir?",
          cancel: "Cancelar",
          persistent: false
        })
          .onOk(() => {
            this.$store.commit('OpenDialogUploadResumoCaixas', false);
            let array = this.uploads;
            this.apagaTodos();
            for (let i = 0; i < array.length; i++) {
              axios
                .post("/lancamentos/delete-resumo-tfl/" + this.caixaId, { arquivo_id: array[i].id })
                .catch(() => {
                  reject();
                });
            }
          })
          .onCancel(() => { });
        return;
      }

      this.$store.commit('OpenDialogUploadResumoCaixas', false);
      this.apagaTodos();
    },
    loadQrcode(){
      if (this.$store.getters.OpenDialogUploadResumoCaixas && this.$q.platform.is.desktop) {
        this.$store.dispatch("getTokenQrcode", true);
      }
      return this.$store.getters.OpenDialogUploadResumoCaixas;
    },
    dizsize() {
      this.carregando = true;
      axios
        .get("/arquivos/dirsize")
        .then(res => {
          if (res.data.success) {
            this.ocupado = res.data.data.ocupado;
            this.percent = res.data.data.percent;
            this.tamanho = res.data.data.tamanho;
          }
          this.carregando = false;
        })
        .catch(() => {
          this.carregando = false;
        });
    },
    apagaItem(arquivo) {
      if (!arquivo) return;

      // Se o arquivo que está sendo visualizado é excluído, a visualização é encerrada
      Dialog.create({
        title: "Deseja mesmo excluir?",
        cancel: "Cancelar",
        persistent: false
      })
        .onOk(() => {
          if (this.reviewingFile != null && arquivo.id === this.reviewingFile.id) {
            this.fechaVisualizacao();
          }

          for (let i = 0; i < arquivo.length; i++) {
            if (arquivo.uploading) {
              return;
            }
          }
          let id = arquivo.id;
          let params = {
            arquivo_id: id
          };
          this.carregando = true;

          axios
            .post("/lancamentos/delete-resumo-tfl/" + this.caixaId, params)
            .then(() => {
              this.carregando = false;

              const index = this.arquivos.indexOf(arquivo);
              this.arquivos.splice(index, 1);

              if (id === this.imgOCRId) {
                this.$store.commit("imgOCRId", null);
              }
            })
            .catch(() => {
              this.carregando = false;
              reject();
            });
        });
    },
    bytesToSize(bytes) {
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes == 0) return "0 Byte";
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
    percentage() {
      return "width: " + this.percent + "%";
    },
    // Arrastar e escolher pelo seletor chegam aqui pelo mesmo caminho: o painel
    // só avisa quais arquivos vieram, quem sobe é a casca.
    processarSelecao(arquivos) {
      if (!arquivos || !arquivos.length) return;

      if (this.uploads.length >= 1) {
        this.uploads.pop();
      } // mantem somente uma notificação de upload de arquivo

      this.selectedFile = arquivos;
      let tam = this.uploads.length;
      let j;
      // neste componente somente é aceito upload de 1 arquivo por vez, por isso o tamanho de selected file sempre será 1, mas este bloco será mantido caso seja necessário no futuro
      for (let i = 0; i < arquivos.length; i++) {
        this.uploads.push({
          fileName: arquivos[i].name,
          fileSize: this.bytesToSize(arquivos[i].size),
          success: false,
          error: false,
          message: "",
          progress: "0%",
          uploading: false,
          delivered: false
        });
        j = tam + i;
        this.onUpload(arquivos[i], this.uploads[j]);
      }
    },
    apagaTodos() {
      this.uploads = [];
      this.arquivos = [];
      this.fechaVisualizacao();
    },
    onUpload(arq, arr) {
      if (!arq.name) {
        arq.name = "Imagem";
      }
      arr.uploading = true;

      const fd = new FormData();
      fd.append("file", arq, arq.name);
      fd.append("is_resumo", 1);
      if (this.despesaQrCode){
        fd.append("movconta_id", this.despesaQrCode);
      } else {
        fd.append("movcaixa_id", this.$route.params.id);
      }

      axios
        .post(axios.defaults.baseURL + "/arquivos/upload", fd, {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: uploadEvent => {
            arr.progress =
              uploadEvent.total
                ? Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%"
                : "...";
          }
        })
        .then(async res => {
          if (res.data.success) {
            arr.message = res.data.message;

            // Processa o OCR da imagem
            await this.processaOCR(res.data.arquivo, false);

            if (this.despesaQrCode){
              this.$store.commit("pushReceitaArquivo", res.data.arquivo);
            } else {
              this.$store.commit("imgOCRId", res.data.arquivo.id);
            }
          } else {
            arr.error = true;
            arr.message = res.data.message;
            Notify.create({
              message: arr.message + "  " + arr.fileName,
              color: "orange",
              position: "top-right"
            });
          }

          arr.success = res.data.success;
          arr.uploading = false;
          arr.delivered = true;

          this.arquivos.unshift(res.data.arquivo);
          this.uploads.pop();
        })
        .catch(() => {
          Notify.create({
            message:
              "Não foi possível fazer o upload do arquivo" +
              arr.fileName +
              ", ou você não possui permissão para isto.",
            color: "red",
            position: "top-right"
          });
          arr.success = false;
          arr.error = true;
          arr.uploading = false;
          arr.progress = "0%";
        });
    },
    async enviaDadosOCR(novo = true) {
      let arquivo = this.arquivos.find(arquivo => arquivo.id === this.imgOCRId);
      if (!arquivo || !arquivo.raw) return;

      this.carregando = true;
      this.carregandoImgId = arquivo.id;
      // Filtra somente os textos ativos para enviar para processar os saldos
      this.blocosMapeados.forEach(bloco => {
        let index = arquivo.raw.findIndex(b => b.Id === bloco.id);
        arquivo.raw[index].ativo = bloco.ativo;
      });

      let dadosImg = {
        save_ocr: true,
        caixa_id: this.caixaId,
        arquivo_id: arquivo.id,
        raw: arquivo.raw
      };
      this.$store
        .dispatch("enviaDadosImg", dadosImg)
        .then(() => {
          this.$store
            .dispatch("buscaCaixa", this.caixaId)
            .then(() => {
              this.carregando = false;
              this.carregandoImgId = null;
            });

          const imgData = this.$store.getters.enviaDadosImgData;
          if (!imgData.success) {
            Notify.create({
              message: imgData.message || "Ocorreu um erro ao processar a Imagem.",
              color: "red",
              position: "top-right"
            });
            return;
          }

          this.blocosAlterados = [];
          if (!novo) {
            this.close();
            return;
          }
          this.apagaTodos();
          this.recuperarResumosCaixa();
        })
        .catch(() => {
          Notify.create({
            message:
              "Ocorreu um erro desconhecido. Tente novamente ou envie outra imagem, caso o erro persista, por favor comunique nossa equipe.",
            color: "red",
            position: "top-right"
          });
          this.carregando = false;
          this.carregandoImgId = null;
        });
    },
    intervalGetToken() {
      if (this.OpenDialogUploadResumoCaixas) {
        this.interval = setInterval(() => {
          this.loadQrcode();
        }, 180000); // 3 minutos
      }
    },
    fechaVisualizacao() {
      this.reviewingFile = null;
      this.blocosMapeados = [];
      this.blocosAlterados = [];
      this.$store.commit("imgOCRId", null);
    },
    reviewItem(arquivo) {
      // Se já tiver alterado os blocos de texto, prompta o usuário de que as
      // alterações serão perdidas se fechar a revisão atual ou revisar outro arquivo
      if (this.blocosAlterados.length && this.reviewingFile && (this.reviewingFile.id !== arquivo.id)) {
        Dialog.create({
          title: "Alterações não salvas",
          message: "Deseja salvar as alterações feitas no arquivo atual?",
          ok: "Salvar",
          cancel: "Cancelar",
        })
          .onOk(() => {
            this.enviaDadosOCR()
              .then(() => {
                this.showReviewingItem(arquivo);
              });
          });
        return;
      }

      this.showReviewingItem(arquivo);
    },
    showReviewingItem(arquivo) {
      // Verifica se o arquivo a ser revisado é um recém enviado ou um enviado anteriormente
      if (!arquivo.raw) {
        this.processaOCR(arquivo);
        return;
      }

      this.blocosMapeados = [];
      this.isImgLoaded = false;
      arquivo.raw.forEach(bloco => this.blocosMapeados.push({ ativo: bloco.ativo, id: bloco.Id }));

      /* Verifica se já tem um arquivo sendo revisado. depois, verifica se o
      arquivo A SER revisado e o arquivo SENDO revisado é o mesmo. se sim,
      fecha a visualizacao*/
      if (this.reviewingFile && (arquivo.id == this.reviewingFile.id)) {
        this.fechaVisualizacao();
        return;
      }

      this.reviewingFile = arquivo;
      this.$store.commit("imgOCRId", this.reviewingFile.id);
    },
    setDimensoesImagem() {
      // Recupera as dimensoes originais da imagem pois o json de textract retorna o mapeamento
      // dos blocos proporcionalmente ao tamanho da imagem que foi processada
      const img = document.getElementById("reviewingImage");
      this.dimensoesImagem = {
        h: img.clientHeight,
        w: img.clientWidth
      };

      this.isImgLoaded = true;
    },
    async processaOCR(arquivo, openReview = true) {
      // Envia a imagem do bucket para o aws.
      // não salva reumo/resumo_log/saldo no bd, apenas o retorno do aws textract.
      this.carregando = true;
      this.carregandoImgId = arquivo.id;

      let dadosImg = {
        save_ocr: false,
        caixa_id: this.caixaId,
        arquivo_id: arquivo.id,
        raw: null
      };

      this.$store
        .dispatch("enviaDadosImg", dadosImg)
        .then(() => {
          const result = this.$store.getters.enviaDadosImgData;

          if (!result.success) {
            Notify.create({
              message: result.message || "Ocorreu um erro ao processar a Imagem.",
              color: "red",
              position: "top-right"
            });

            arquivo.raw = null;
            arquivo.delivered = false;
          } else {
            arquivo.raw = result.raw;
            arquivo.delivered = true;
          }

          arquivo.uploading = false;
          arquivo.processing = false;
          this.carregando = false;
          this.carregandoImgId = null;

          if (openReview && result.success) {
            this.reviewItem(arquivo);
          }
        })
        .catch(() => {
          Notify.create({
            message:
              "Ocorreu um erro ao processar a imagem. Tente novamente ou envie outra imagem, caso o erro persista, por favor comunique nossa equipe.",
            color: "red",
            position: "top-right"
          });
          this.carregando = false;
          this.carregandoImgId = null;
        });
    },
    calculaArea(block) {
      // Dinamicamente calcula a área da div de overlay para cada texto identificado conforme o retorno do textract
      if (this.dimensoesImagem) {
        let width = block.BoundingBox.Width * this.dimensoesImagem.w;
        let height = block.BoundingBox.Height * this.dimensoesImagem.h;
        let left = block.BoundingBox.Left * this.dimensoesImagem.w;
        let top = block.BoundingBox.Top * this.dimensoesImagem.h;

        let retornoStyle = {
          cursor: 'pointer',
          borderWidth: '2px',
          borderStyle: 'solid',
          position: 'absolute',
          width: '' + width + 'px',
          height: '' + height + 'px',
          left: '' + left + 'px',
          top: '' + top + 'px'
        };

        if (block.ativo) {
          retornoStyle.backgroundColor = 'rgba(66, 133, 244, 0.2)';
          retornoStyle.borderColor = 'rgb(66, 133, 244)';
        } else {
          retornoStyle.backgroundColor = 'rgba(255, 100, 100, 0.2)';
          retornoStyle.borderColor = 'rgb(255, 100, 100)';
        }

        return retornoStyle;
      }
    },
    toggleBloco(block) {
      if (this.movcaixa.status !== 'A') return;
      /*faz com que os textos identificados possam ser ativados ou desativados
      conforme o usuário queira (para possível missclick)*/
      let index = this.blocosMapeados.findIndex(b => block.Id === b.id);
      this.blocosMapeados[index].ativo = !this.blocosMapeados[index].ativo;

      let b = document.getElementById(block.Id);
      if (this.blocosMapeados[index].ativo) {
        b.style.backgroundColor = 'rgba(66, 133, 244, 0.2)';
        b.style.borderColor = 'rgb(66, 133, 244)';
      } else {
        b.style.backgroundColor = 'rgba(255, 100, 100, 0.2)';
        b.style.borderColor = 'rgb(255, 100, 100)';
      }

      if (!this.blocosAlterados.includes(this.blocosMapeados[index].id)) {
        this.blocosAlterados.push(this.blocosMapeados[index].id);
        return;
      }
      this.blocosAlterados.splice(this.blocosAlterados.indexOf(this.blocosMapeados[index].id), 1);
    },
    recuperarResumosCaixa() {
      /*recupera do BD os resumos enviados anteriormente relacionados a esse caixa*/
      this.arquivos = [];
      this.loadingArquivos = true;
      axios
        .get("/lancamentos/arquivos/" + this.caixaId)
        .then(res => {
          this.arquivos = res.data.arquivos;
          this.loadingArquivos = false;
        })
        .catch(() => {
          Notify.create({
            message: "Não foi possível recuperar os resumos TFL anteriores",
            color: "red",
            position: "top-right"
          });
          this.loadingArquivos = false;
        });
    },
    isAtivo(block) {
      let index = this.blocosMapeados.findIndex(b => block.Id === b.id);
      return this.blocosMapeados[index].ativo;
    },
    async buscarRelatorioCaixa() {
      this.carregandoRelatorioCaixa = true;
      this.retornoImportacaoCaixa = null;
      try {
        // O backend resolve terminal e data pelo próprio caixa (caixa_id = Movcaixa id).
        // Não enviamos terminal/data do front: o cadastro carregado no navegador pode
        // estar desatualizado e causaria relatório do terminal errado.
        const res = await this.$store.dispatch("iniciarRelatorioTerminalCaixa", { caixa_id: this.caixaId });

        if (res && res.error) {
          this.carregandoRelatorioCaixa = false;
          this.$q.notify({
            message: (res.error && res.error.message) || "Erro ao buscar relatório.",
            color: "red",
            position: "top-right",
          });
          return;
        }

        const payload = (res && res.data && res.data.data) || {};
        const status = payload.status;

        if (status === "concluido") {
          this.dadosRelatorioCaixa = payload.dados || null;
          this.relatorioCaixaCarregado = true;
          this.carregandoRelatorioCaixa = false;
          this.$q.notify({
            message: "Relatório importado com sucesso!",
            color: "green",
            position: "top-right",
          });
          return;
        }

        this.dadosRelatorioCaixa = null;
        this.relatorioCaixaCarregado = false;
        this.$q.notify({
          message: "Solicitação enviada. O relatório está sendo gerado em segundo plano — pode levar alguns minutos.",
          color: "blue",
          position: "top-right",
          timeout: 6000,
        });
      } catch (e) {
        this.carregandoRelatorioCaixa = false;
        this.$q.notify({
          message: "Erro ao buscar relatório: " + (e && e.message ? e.message : ""),
          color: "red",
          position: "top-right",
        });
      }
    },
    confirmarLiberacao() {
      this.$q.dialog({
        title: "Liberar importação",
        message: textoConfirmacaoLiberacao(this.conexaoCaixaRelatorioBase),
        cancel: true,
        persistent: true,
      }).onOk(() => this.enviarRelatorioCaixa(true));
    },
    fecharAposImportacaoCaixa() {
      this.relatorioCaixaCarregado = false;
      this.dadosRelatorioCaixa = null;
      this.retornoImportacaoCaixa = null;
      this.close();
    },
    async enviarRelatorioCaixa(liberar = false) {
      // Efetiva a importação do relatório já carregado para o caixa do operador.
      // Usa o job_id do relatório concluído — o backend relê os dados do job pelo id.
      const jobId = this.conexaoCaixaRelatorioJobId;
      if (!jobId || this.conexaoCaixaRelatorioCaixaId !== this.caixaId) {
        this.$q.notify({
          message: "Nenhum relatório carregado para enviar. Busque o relatório primeiro.",
          color: "orange",
          position: "top-right",
        });
        return;
      }

      this.enviandoRelatorioCaixa = true;
      try {
        const res = await axios.post(
          "/lancamentos/add-saldo-conexao-caixa/" + this.caixaId,
          { job_id: jobId, liberar_base_lancamentos: liberar === true }
        );

        if (res && res.error) {
          this.$q.notify({
            message: (res.error && res.error.message) || "Erro ao enviar relatório para o caixa.",
            color: "red",
            position: "top-right",
          });
          return;
        }

        const retorno = (res && res.data) || {};
        const ok = retorno.success === true;
        this.retornoImportacaoCaixa = retorno;

        if (ok) {
          await this.atualizarDadosAposImportacaoCaixa();
        }

        if (!ok) {
          this.$q.notify({
            message: retorno.message || "Não foi possível enviar o relatório.",
            color: "red",
            position: "top-right",
          });
          return;
        }

        if (this.importacaoCaixaComPendencias) {
          return;
        }

        this.$q.notify({
          message: retorno.message || "Relatório enviado ao caixa com sucesso!",
          color: "green",
          position: "top-right",
        });

        this.relatorioCaixaCarregado = false;
        this.dadosRelatorioCaixa = null;
        this.retornoImportacaoCaixa = null;
        // Importado sem nada a conferir: o trabalho do modal acabou.
        this.close();
      } catch (e) {
        this.$q.notify({
          message: "Erro ao enviar relatório: " + (e && e.message ? e.message : ""),
          color: "red",
          position: "top-right",
        });
      } finally {
        this.enviandoRelatorioCaixa = false;
      }
    },
  },
  watch: {
    OpenDialogUploadResumoCaixas(val) {
      if (val) {
        // Cada abertura zera as flags de "uma vez por abertura" e volta para a
        // aba padrão — o modal recomeça do zero.
        this.reiniciarAbas();

        // Ao abrir o modal, garante config+status frescos do Conexão Parceiros Caixa —
        // assim os recursos não dependem de o usuário ter aberto antes a aba
        // de Parâmetros → Conexão para destravar. Só busca quando o recurso é
        // aplicável (lotérica + app contratado + permissão).
        if (this.conexaoCaixaDisponivel) {
          this.$store.dispatch("fetchConexaoCaixaConfig");
          this.$store.dispatch("fetchStatusConexaoCaixa");
        }
        return this.intervalGetToken();
      }
      return clearInterval(this.interval);
    },
    // Config e status do Conexão chegam por duas requisições assíncronas soltas
    // na abertura do modal. Quem clica na aba antes do status voltar cai no ramo
    // "agente não pronto" e, como já está na aba, nenhuma troca de aba
    // redispararia — ficava só o botão. Aqui a aba se acerta sozinha assim que o
    // agente aparece; `caixaJaConsultada` continua garantindo uma só por abertura.
    conexaoCaixaPodeRelatorio(pronto) {
      if (!pronto) return;
      if (this.abaAtiva !== "conexao") return;
      if (!this.OpenDialogUploadResumoCaixas) return;

      this.aoEntrarNaAbaConexao();
    },
    conexaoCaixaRelatorioTemErro(novo) {
      if (!novo || !this.conexaoCaixaRelatorioErro) return;
      if (!this.OpenDialogUploadResumoCaixas) return;
      this.carregandoRelatorioCaixa = false;
      this.notificarErroConexaoCaixa(this.conexaoCaixaRelatorioErro);
    },
    conexaoCaixaRelatorioConcluido(novo) {
      if (!novo) return;
      if (!this.OpenDialogUploadResumoCaixas) return;
      this.dadosRelatorioCaixa = this.conexaoCaixaRelatorioResultado || null;
      this.relatorioCaixaCarregado = true;
      this.carregandoRelatorioCaixa = false;
      this.$q.notify({
        message: "Relatório importado — pronto para enviar.",
        color: "green",
        position: "top-right",
      });
    },
  },
  created() {
    this.reiniciarAbas();
  },
  mounted() {
    this.$store.commit("imgOCRId", null);
  }
};
</script>
